import React from 'react';
import { Link } from 'react-router-dom';
import {
  Container,
  Box,
  Typography,
  Button,
} from '@mui/material';
import CancelIcon from '@mui/icons-material/Cancel';

const PaiementAnnule = () => {
  return (
    <Container maxWidth="md" sx={{ py: 6 }}>
      <Box sx={{ textAlign: 'center', p: 4 }}>
        <CancelIcon sx={{ fontSize: 80, color: '#c62828', mb: 3 }} />

        <Typography variant="h4" sx={{ mb: 2, fontWeight: 600 }}>
          Paiement annulé
        </Typography>

        <Typography variant="body1" sx={{ mb: 3, color: '#666' }}>
          Votre paiement par carte a été annulé. Aucun montant n'a été débité.
        </Typography>
        <Typography variant="body1" sx={{ mb: 3, color: '#666' }}>
          Vos articles sont toujours dans votre panier — vous pouvez réessayer le paiement,
          choisir le virement Interac, ou nous contacter pour de l'aide.
        </Typography>

        <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', mt: 5 }}>
          <Button component={Link} to="/panier" variant="contained" sx={{ minWidth: 200 }}>
            Retour au panier
          </Button>
          <Button component={Link} to="/contact" variant="outlined" sx={{ minWidth: 200 }}>
            Nous contacter
          </Button>
        </Box>
      </Box>
    </Container>
  );
};

export default PaiementAnnule;
